import React from "react";
import $ from "jquery";
import * as omnimap from "../../../../../api/omnimap/omnimapActions";
import * as CallBackFunctions from "../functions/callBackFunctions";
import * as CommonFunctions from "../functions/commonFunctions";
import * as GC from "../../../../common/common";
import { StartActionActivity } from "../../../../../api/omnimap/omnimapApi";

class ToevoegenUitvoerder extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  async hadleSubmit() {
    $("#cover-spin").show(0);

    //** save uitvoerder
    var uitvoerderModel = {
      uitvoerders: [],
    };
    var toezichthouder = $("input[name=uitvoerder]:checked");
    for (let i = 0; i < toezichthouder.length; i++) {
      var content = {
        identification: toezichthouder[i].id,
        display: [
          {
            path: "$.alias",
            value: toezichthouder[i].nextSibling.innerText,
          },
        ],
      };
      uitvoerderModel.uitvoerders.push(content);
    }
    await GC.StartActivity(
      uitvoerderModel,
      [window.$catalog_work_plans_selectedIds],
      "c2c28e89-63ee-4714-8051-4b425f2c0976",
      this.submitCallback,
      window.$catalog_management_units_token
    );
  }
  submitCallback() {
    GC.sleep(1000).then(() => {
      $("#toevoegen_uitvoerder").modal("hide");
      $("#cover-spin").hide(0);
    });
  }
  async componentDidMount() {
    var that = this;

    $("#toevoegen_uitvoerder").on("show.bs.modal", function (event) {
      omnimap
        .GetUserByRoleAction(
          1,
          30,
          "uitvoerder",
          window.$catalog_management_units_token
        )
        .then((result) =>
          CallBackFunctions.ToevoegenToezichthouderCallbackForCreate(
            result,
            "toevoegen-uitvoerder",
            "uitvoerder"
          )
        );
    });
  }

  render() {
    return (
      <div>
        <div
          className="modal fade"
          tabIndex={-1}
          role="dialog"
          id="toevoegen_uitvoerder"
        >
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Toevoegen uitvoerder(s)</h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                />
              </div>
              <div className="modal-body">
                {/* //** Toevoegen uitvoerder(s)  */}
                <div className="modal-scroll">
                  {" "}
                  <label>Uitvoerders </label>
                  <div id="toevoegen-uitvoerder" className="radio-grp" />
                </div>
                <br />
                <br />
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  id="save-werkplann"
                  className="btn-modal"
                  onClick={this.hadleSubmit.bind(this)}
                >
                  Verwerken
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ToevoegenUitvoerder;
